import {
  AssemblyTemplateField,
  DefectLegend,
  GetStructureDetailsQuery,
  RemediationScoreConfig,
  GetAllPointOfInterestTemplatesQuery,
  PointOfInterestTemplate,
  QuerySummaryItem,
  AllTemplatesForBuilderQuery,
  LogsTemplateQuery,
  LogsTemplateField,
} from '@/__generated__/graphql';
import { SnackbarMessage } from '@/types';
import { atom } from 'jotai';

export const selectedPOIType = atom<Partial<PointOfInterestTemplate> | undefined>(undefined);

export const allPOITypes = atom<
  GetAllPointOfInterestTemplatesQuery['allPointOfInterestTemplate'] | undefined
>(undefined);

export const assemblyTemplate = atom<AllTemplatesForBuilderQuery['allTemplates'][0] | undefined>(
  undefined
);

export const structureDefectLegends = atom<DefectLegend[] | undefined>(undefined);

export const snackbarMessage = atom<SnackbarMessage>({ shouldShow: false });

export const selectedTemplateId = atom<string | undefined>(undefined);

export const assemblyFields = atom<AssemblyTemplateField[] | undefined>(undefined);

export const paintBlockFields = atom<AssemblyTemplateField[] | undefined>(undefined);

export const riskConfigData = atom<RemediationScoreConfig>({
  area: null,
  cof: null,
  poi: null,
});

export const selectedTemplateField = atom<AssemblyTemplateField | undefined>(undefined);

export const querySummaries = atom<QuerySummaryItem[] | undefined>(undefined);

export const selectedQuerySummary = atom<QuerySummaryItem | undefined>(undefined);

export const selectedStructure = atom<GetStructureDetailsQuery['structure'] | undefined>(undefined);

export const selectedWorklogsTemplateId = atom<string | undefined>(undefined);

export const selectedWorklogsTemplate = atom<LogsTemplateQuery['logsTemplate'] | undefined>(
  undefined
);

export const worklogsTemplateFields = atom<LogsTemplateField[] | undefined>(undefined);

export const selectedWorklogsTemplateField = atom<LogsTemplateField | undefined>(undefined);
